<template>
  <div class="vendor-tile shadow-sm shadow-sm-hover p-2 p-sm-3">
    <div class="d-flex">
      <div class="flex-grow-1 d-flex flex-column">
        <div class="h5 mb-0 text-break">
          {{ name | truncate(60) }}
        </div>
        <p v-if="description" class="mb-0 text-sm text-muted">{{ description }}</p>
        <div v-if="categories || address" class="mt-2">
          <Attribute v-if="categories" :value="categories" icon="icon-tag" />
          <Attribute v-if="address" :value="address" icon="icon-pin-sm" />
        </div>
        <div v-if="badges.length" class="mt-2">
          <BadgeGroup>
            <Badge
              v-for="(badge, index) in badges"
              :key="index"
              :text="badge.text"
              :variant="badge.variant"
            ></Badge>
          </BadgeGroup>
        </div>
      </div>
      <div v-if="image" class="flex-shrink-0 d-none d-sm-flex pl-2">
        <Avatar :src="image" :alt="name" />
      </div>
    </div>
    <div v-if="productLink || link" class="flex-grow-1 mt-2 d-flex align-items-end">
      <div class="mt-n1 ml-n1 d-flex flex-wrap">
        <ActionButton v-if="link" :href="link.url" variant="small" class="mt-1 ml-1 stretched-link">
          {{ link.text }}
        </ActionButton>
        <ActionButton
          v-if="productLink"
          :href="productLink.url"
          variant="small"
          class="mt-1 ml-1 position-relative z-1"
        >
          {{ productLink.text }}
        </ActionButton>
      </div>
    </div>
  </div>
</template>

<script>
import ActionButton from "./ActionButton.vue";
import Avatar from "./Avatar.vue";
import Attribute from "./Attribute.vue";
import Badge from "./Badge.vue";
import BadgeGroup from "./BadgeGroup.vue";

export default {
  name: "VendorTile",
  components: {
    ActionButton,
    Avatar,
    Attribute,
    Badge,
    BadgeGroup,
  },
  props: {
    image: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: "",
    },
    address: {
      type: String,
      default: "",
    },
    badges: {
      type: Array,
      default: () => [],
    },
    categories: {
      type: String,
      default: "",
    },
    link: {
      type: Object,
      default: () => {},
    },
    productLink: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/global";

.vendor-tile {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  border: $width-border-thin solid $gray-200;
  border-radius: $border-radius;
  overflow: hidden;
  position: relative;
  background: $white;
  height: 100%;
  transition: border-color $transition-duration-short;

  @include hover-states {
    border-color: $gray-300;
  }
}
</style>
